import React from 'react';
import {
    fetchSlaRequest,
    fetchSlaRequestSuccess,
    fetchSlaRequestFailer,
    createSlaRequest,
    createSlaRequestSuccess,
    createSlaRequestFailer
} from './SlaAction';
import DataService from "../../../../../../../../Service";

export const fetchSla = (param: any) => {
    return (dispatch: any) => {
        dispatch(fetchSlaRequest());
        DataService.getData(param, 'SLA_detail').then((res) => {
            if (res?.success) {
                dispatch(fetchSlaRequestSuccess(res));
            }
        }).catch((error) => {
            dispatch(fetchSlaRequestFailer(error));
        })
    }
}


export const createSla = (formData: any, param: any, onClose: () => void) => {
    return (dispatch: any) => {
        dispatch(createSlaRequest());
        DataService.createData(formData, 'create_SLA_detail').then((res) => {
            if (res?.success) {
                dispatch(createSlaRequestSuccess(res));
                dispatch(fetchSla(param))
                onClose();
            }
        }).catch((error) => {
            dispatch(createSlaRequestFailer(error));
        })
    }
}


